import { Copy, Trash2 } from 'lucide-react'
import { Row } from 'src/shared/components/Semantic/all'
import { Button } from 'src/shared/components/ui/button'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const CanvasSelectionToolbar = ({
  count,
  screenX,
  screenY,
  canDuplicate,
  onDuplicate,
  onDelete,
}: {
  count: number
  screenX: number
  screenY: number
  canDuplicate: boolean
  onDuplicate: () => void
  onDelete: () => void
}) => {
  const { t } = useLocalization()

  return (
    <Row
      className="pointer-events-auto absolute z-50 items-center gap-1 rounded-full border border-border bg-card px-1.5 py-1 shadow-lg"
      style={{
        left: screenX,
        top: screenY,
        transform: 'translate(-50%, calc(-100% - 12px))',
      }}
      onPointerDown={(e) => e.stopPropagation()}
    >
      <span className="px-2 text-xs font-medium text-muted-foreground">
        {t(`${count} selected`, `${count} valda`)}
      </span>
      {canDuplicate ? (
        <Button
          variant="ghost"
          size="sm"
          className="h-7 gap-1.5 rounded-full px-2.5"
          onClick={onDuplicate}
        >
          <Copy className="h-3.5 w-3.5" />
          {t('Duplicate', 'Duplicera')}
        </Button>
      ) : null}
      <Button
        variant="ghost"
        size="sm"
        className="h-7 gap-1.5 rounded-full px-2.5 text-red-600 hover:bg-red-50 hover:text-red-700"
        onClick={onDelete}
      >
        <Trash2 className="h-3.5 w-3.5" />
        {t('Delete', 'Ta bort')}
      </Button>
    </Row>
  )
}
